export default __webpack_public_path__ + "static/media/76.88355607.jpg";